import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "w-full text-center" }
const _hoisted_3 = ["disabled"]

import { Form } from 'vee-validate';
import { computed, ref, watch } from 'vue';
import StoreEmployeeSelector from '@/storecontext/shared/employees/ui/StoreEmployeeSelector.vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import {
    CheckOutOnlinePaymentRequest,
    CheckOutPosRequest,
    OnlinePaymentOption, OnlinePaymentOptionType, OnlinePaymentType,
    PaymentOptionType,
    PosPaymentOption,
} from '@/storecontext/shared/api/server-apis';
import useStoreEmployees from '@/storecontext/shared/employees/useStoreEmployees';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentSettings',
  setup(__props) {

const labels = useBlockLabels();
const { selectedPaymentOption, gotoPOS, gotoOnlinePayment } = useCheckout();
const { loaded, defaultEmployee, getEmployeeModelFromId } = useStoreEmployees();

const selectedSalesPersonId = ref<string>();
const selectedPaymentOptionType = ref<string>(OnlinePaymentType.OnlinePaymentFull.toString());

watch(loaded, (value) => {
    if (value) {
        selectedSalesPersonId.value = defaultEmployee.value?.id;
    }
}, { immediate: true });

const isOnlinePaymentOption = computed<boolean>(() => {
    return selectedPaymentOption.value?.paymentOptionType === PaymentOptionType.Online;
});

const isPosV2Payment = computed<boolean>(() => {
    if (selectedPaymentOption.value?.paymentOptionType === PaymentOptionType.Pos) {
        const posPaymentType = selectedPaymentOption.value as PosPaymentOption;
        return posPaymentType.isPosV2Payment;
    }

    return false;
});

const onlinePaymentOptionTypes = computed<OnlinePaymentOptionType[]>(() => {
    let optionTypes: OnlinePaymentOptionType[] = [];
    if (isOnlinePaymentOption.value) {
        const option = selectedPaymentOption.value as OnlinePaymentOption;
        optionTypes = option.paymentOptionTypes;
    }
    return optionTypes;
});

const gotoPayment = async({ soldByEmployee, onlinePaymentType }): Promise<void> => {
    if (soldByEmployee) {
        soldByEmployee = getEmployeeModelFromId(soldByEmployee);
    }
    const request: CheckOutPosRequest | CheckOutOnlinePaymentRequest = {
        onlinePaymentType,
        soldByEmployee,
    };
    return isOnlinePaymentOption.value
        ? await gotoOnlinePayment(request as CheckOutOnlinePaymentRequest)
        : await gotoPOS(request as CheckOutPosRequest);
};


return (_ctx: any,_cache: any) => {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_unref(Form), {
    class: "max-w-380 text-left mx-auto mt-10",
    onSubmit: gotoPayment
  }, {
    default: _withCtx(({ isSubmitting }) => [
      _createVNode(StoreEmployeeSelector, {
        modelValue: selectedSalesPersonId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSalesPersonId).value = $event)),
        name: "soldByEmployee",
        label: _unref(labels).paymentSettingsSelectSalesPerson,
        class: "mb-x6"
      }, null, 8, ["modelValue", "label"]),
      (_unref(isOnlinePaymentOption))
        ? (_openBlock(), _createBlock(_component_InputSelect, {
            key: 0,
            modelValue: selectedPaymentOptionType.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPaymentOptionType).value = $event)),
            class: "mb-x6",
            name: "onlinePaymentType",
            label: _unref(labels).paymentSettingsSelectPaymentType,
            rules: "required",
            "show-errors": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(onlinePaymentOptionTypes), (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.paymentType,
                  value: option.paymentType
                }, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels)[option.description.label], option.description.namedParams)), 9, _hoisted_1))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "label"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "submit",
          disabled: isSubmitting,
          class: "c-button c-button--primary flex flex-nowrap mx-auto items-center"
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(isOnlinePaymentOption) ? _unref(labels).paymentGotoOnlineTypeButton : (_unref(isPosV2Payment) ? _unref(labels).saveOrderToPosButton : _unref(labels).paymentGotoPosTypeButton)), 1),
          _createVNode(_component_c_icon, {
            name: "icon-arrow-small",
            class: "w-8 h-8 mt-1 ml-6 xl:h-10 xl:ml-8 xl:-mt-1"
          })
        ], 8, _hoisted_3)
      ])
    ]),
    _: 1
  }))
}
}

})